




































import Vue from "vue";

export default Vue.extend({
  name: "BillingHistory",
  props: ["invoices"],
  methods: {
    convertTotalToDollars(total: number) {
      return (total / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    getFormattedDate(unix: number) {
      const ms = unix * 1000;
      const date = new Date(ms);
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return `${
        months[date.getMonth()]
      } ${date.getDate()}, ${date.getFullYear()}`;
    },
    getDescription(line: any) {
      return line.quantity + " x " + line.price.nickname || line.description; // ? line.description.split("(")[0] : "Not Found";
    }
  },
  computed: {
    invoiceLines() {
      return (
        this.invoices &&
        this.invoices.reduce((acc: any, cur: any) => {
          if (cur.paid) {
            cur.lines.data.forEach((line: any) => {
              acc.push({
                line: line,
                created: cur.created,
                download: cur.invoicePdf,
                invoice: cur
              });
            });
          }

          return acc;
        }, [])
      );
    }
  }
});
